<template>
  <el-form ref="taskForm" :model="tableData" :rules="rules" class="task">
    <div class="task__header">
      <div class="task__header-title-wrapper">
        <svg-icon name="arrow-left" class="task__header-arrow" />
        <p class="task__header-title">{{ taskTitle }}</p>
      </div>
      <p class="task__header-delete">Удалить</p>
    </div>
    <el-row :gutter="20">
      <el-col :md="16">
        <el-form-item label="Название задания">
          <el-input v-model="tableData.name" />
        </el-form-item>
      </el-col>
      <el-col :md="8"></el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="16">
        <el-form-item label="Тип">
          <el-select v-model="tableData.type" class="w-full">
            <el-option v-for="item in typeOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="8"></el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="16">
        <el-form-item label="Тип задания">
          <el-select v-model="tableData.taskType" class="w-full">
            <el-option v-for="item in taskTypeOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="8"></el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="16">
        <el-form-item label="Количество очков">
          <el-input v-model="tableData.points" />
        </el-form-item>
      </el-col>
      <el-col :md="8"></el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="16">
        <el-form-item label="Описание задания">
          <el-input v-model="tableData.taskDescription" type="textarea" :rows="4" />
        </el-form-item>
      </el-col>
      <el-col :md="8"></el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="16">
        <el-form-item label="Xapi-файл">
          <el-upload
            v-if="!uploadFileList.length"
            ref="upload"
            class="upload"
            :auto-upload="false"
            action=""
            :show-file-list="false"
            :file-list="uploadFileList"
            :on-change="handleUploadChange"
          >
            <a slot="trigger" href="#" class="task__add-btn" @click.prevent="addFile">
              <svg-icon name="plus" class="task__plus-icon" />
              Добавить
            </a>
          </el-upload>
          <ul v-if="uploadFileList.length" class="task__upload-list">
            <li v-for="(item, index) in uploadFileList" :key="item.uid">
              <img src="/img/filetypes/xapi.svg" alt="icon" class="task__file-icon" />
              <span>{{ item.name }}</span>
              <svg-icon name="times" class="task__close-icon" @click="deleteFile(index)" />
            </li>
          </ul>
        </el-form-item>
      </el-col>
      <el-col :md="8"></el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="16">
        <el-form-item>
          <el-button type="primary" round :disabled="!uploadFileList.length"
            >Предпросмотр</el-button
          >
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'OverviewCourseTask',
  props: {
    formModel: {
      type: Object,
      required: true
    },
    courseData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rules: {},
      isEditable: null,
      tableData: {},
      typeOptions: ['Основное', 'Дополнительное'],
      taskTypeOptions: ['Контент'],
      uploadFileList: []
    }
  },
  computed: {
    taskTitle() {
      return this.$route.params.task.task.split('.')[0] || ''
    }
  },
  mounted() {
    this.getTaskData()
  },
  methods: {
    getTaskData() {
      const { type, taskType, points } = this.$route.params.task
      this.tableData = {
        name: this.$route.params.task.task.split('.')[1],
        type,
        taskType,
        points
      }
    },

    handleUploadChange(_, fileList) {
      this.uploadFileList = fileList
    },

    deleteFile(index) {
      this.uploadFileList.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="scss">
.task {
  &__plus-icon {
    height: 20px;
    width: 20px;
    stroke: $luchmara;
  }

  &__add-btn {
    display: flex;
    align-items: center;
    width: 100%;
    font-weight: bold;
    font-size: 16px;
    color: $luchmara;
  }

  &__close-icon {
    margin-left: auto;
    stroke: $red;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  &__file-icon {
    margin-right: 4px;
  }

  &__upload-list {
    display: flex;
    width: 100%;

    li {
      display: flex;
      align-items: center;
      width: 100%;
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;

    @include sm-and-down {
      align-items: center;
    }
  }

  &__header-delete {
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.2px;
    color: $red;
    cursor: pointer;
  }

  &__header-title {
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.35px;
    color: $deepdark;

    &-wrapper {
      display: flex;
      align-items: center;
    }
  }

  &__header-arrow {
    margin-right: 16px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.upload {
  ::v-deep div {
    width: 100%;
  }
}

::v-deep .el-form-item__label {
  font-size: 12px;
  line-height: 20px;
  padding-left: 6px;
  display: flex;
  color: #b6b9c3;
  margin-bottom: 4px;
}
</style>
